export const checkUnsavedChanges = () => {
    // Logic to check if there are unsaved changes
    // For now, checks window.__hasUnsavedChanges flag
    return window.__hasUnsavedChanges === true;
};

export const markUnsavedChanges = () => {
    window.__hasUnsavedChanges = true;
};

export const clearUnsavedChanges = () => {
    window.__hasUnsavedChanges = false;
};
